import { useEffect } from 'react';
import store, {
  useRecoilValue,
  useRecoilCallback,
  useGotoRecoilSnapshot,
} from '@store';
import { useBodyScrollLock, useFiltersSidebar } from '@hooks';

export const useOverlay = () => {
  const gotoSnapshot = useGotoRecoilSnapshot();
  const overlay = useRecoilValue(store.overlay);
  const { lockScroll, unlockScroll } = useBodyScrollLock();
  const [, { closeFiltersSidebar }] = useFiltersSidebar();

  const closeOverlay = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();

        try {
          const updatedState = snapshot
            .map(({ set }) => set(store.modal, null))
            .map(({ set }) => set(store.sidebar, false))
            .map(({ set }) => set(store.overlay, false));

          // update state
          gotoSnapshot(updatedState);
        } finally {
          release();
        }
        closeFiltersSidebar();
      },
    []
  );

  useEffect(() => {
    if (overlay) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [overlay]);

  return [{ overlay }, { closeOverlay }];
};
